import * as Yup from 'yup';

export const ABOUT_BANK_VALIDATION_SCHEMA = Yup.object().shape({
  description: Yup.string().required('Обязательное поле').max(500, 'Превышено допустимое количество символов'),
  image: Yup.object({
    filename: Yup.string().required(),
    signed_id: Yup.string(),
    url: Yup.string(),
  })
    .nullable()
    .test('required', 'Обязательное поле', (value) => value !== null),
});
